import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import gregorian from 'react-date-object/calendars/gregorian';
export default function formatDate(data, format, type) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (data) {
        var date = new DateObject(data);
        date.calendar = type === 'gregorian' ? gregorian : persian;
        return date.format(format);
    }
    return null;
}
//# sourceMappingURL=formatDate.js.map